import { Container } from 'components/shared';
import { DesktopComponent } from './DesktopComponent';
import { MobileComponent } from './MobileComponent';
import styles from './index.module.css';

export const BentoSection = ({ className }: { className?: string }) => {
  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <div className={styles.desktopOnly}>
          <DesktopComponent />
        </div>
        <div className={styles.mobileOnly}>
          <MobileComponent />
        </div>
      </Container>

      {/* <MagicModal /> */}
    </section>
  );
};
